/* Mondopacks PDP — scoped to .mp, safe to re-run in the theme editor */
(function () {
  "use strict";

  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  }

  function init(root) {
    if (!root || root.dataset.mpReady === "1") return;
    root.dataset.mpReady = "1";

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var hasIO = "IntersectionObserver" in window;
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------- scroll reveals ---------- */
    if (hasIO && !reduce) {
      var ro = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); ro.unobserve(e.target); }
        });
      }, { threshold: 0.18 });
      $$(".rv").forEach(function (el) { ro.observe(el); });
    } else {
      $$(".rv").forEach(function (el) { el.classList.add("in"); });
    }

    /* ---------- angle switcher ---------- */
    var tabs = $("[data-vtabs]"), stage = $("[data-stage]"), vdesc = $("[data-vdesc]");
    if (tabs && stage) {
      tabs.addEventListener("click", function (e) {
        var b = e.target.closest("button"); if (!b) return;
        var v = b.dataset.v;
        this.querySelectorAll("button").forEach(function (x) {
          x.setAttribute("aria-pressed", String(x === b));
        });
        stage.querySelectorAll("img").forEach(function (i) {
          i.classList.toggle("on", i.dataset.v === v);
        });
        if (vdesc && b.dataset.desc) vdesc.textContent = b.dataset.desc;
      });
    }

    /* ---------- pinned media column ---------- */
    var pm = $("[data-pinmedia]");
    if (pm && hasIO) {
      var pimgs = pm.querySelectorAll("img");
      var pio = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.dataset.i, 10);
          pimgs.forEach(function (im, j) { im.classList.toggle("on", j === i); });
        });
      }, { rootMargin: "-45% 0px -45% 0px" });
      $$(".pstep").forEach(function (s) { pio.observe(s); });
    }

    /* ---------- packing calculator ---------- */
    var itemsEl = $("[data-items]");
    if (itemsEl) {
      var CAP = parseFloat(itemsEl.dataset.cap || "18");
      var ITEMS = JSON.parse(itemsEl.dataset.list || "[]");
      var vac = $("[data-vac]"), bar = $("[data-bar]"), used = $("[data-used]"),
          verd = $("[data-verdict]");
      var fill = bar ? bar.querySelector("i") : null;

      ITEMS.forEach(function (it, i) {
        var l = document.createElement("label");
        l.className = "item";
        l.innerHTML = '<input type="checkbox" data-i="' + i + '"' + (it.on ? " checked" : "") +
                      '><span class="nm"></span><span class="vol"></span>';
        l.querySelector(".nm").textContent = it.n;
        itemsEl.appendChild(l);
      });

      var render = function () {
        var total = 0, c = vac && vac.checked;
        ITEMS.forEach(function (it, i) {
          var v = (it.soft && c) ? it.v * 0.65 : it.v;
          var cb = itemsEl.querySelector('[data-i="' + i + '"]');
          cb.parentNode.querySelector(".vol").textContent = v.toFixed(1) + "L";
          if (cb.checked) total += v;
        });
        if (fill) fill.style.width = Math.min(total / CAP * 100, 100) + "%";
        if (used) used.textContent = total.toFixed(1) + "L";
        if (bar) bar.classList.toggle("over", total > CAP);
        if (!verd) return;
        verd.classList.toggle("over", total > CAP);
        var left = CAP - total;
        if (total === 0) verd.textContent = "Nothing packed yet. Start ticking.";
        else if (total > CAP) verd.textContent = "Over by " + (total - CAP).toFixed(1) + "L." +
          (c ? " Drop the bulkiest item, or move the shoes to the base compartment."
             : " Pump the soft goods down and most of that disappears.");
        else if (left < 2) verd.textContent = "Fits, with " + left.toFixed(1) +
          "L spare \u2014 full but closable.";
        else verd.textContent = "Fits, with " + left.toFixed(1) +
          "L spare for whatever you pick up on the way home.";
      };
      itemsEl.addEventListener("change", render);
      if (vac) vac.addEventListener("change", render);
      render();
    }

    /* ---------- FAQ ---------- */
    var faq = $("[data-faq]");
    if (faq) {
      faq.addEventListener("click", function (e) {
        var btn = e.target.closest("button"); if (!btn) return;
        var q = btn.parentElement, a = q.querySelector(".a"), open = q.hasAttribute("open");
        this.querySelectorAll(".q[open]").forEach(function (o) {
          o.removeAttribute("open");
          o.querySelector(".a").style.maxHeight = null;
        });
        if (!open) { q.setAttribute("open", ""); a.style.maxHeight = a.scrollHeight + "px"; }
      });
    }

    /* ---------- quantity ---------- */
    var qty = 1;
    var qEl = $("[data-qty-value]"), totEl = $("[data-total]");
    var unit = parseInt(root.dataset.price || "0", 10);   // cents
    var syncTotal = function () {
      totEl = $("[data-total]");                          // may have been re-rendered
      if (totEl && unit) totEl.textContent = money(unit * qty);
    };
    var plus = $("[data-qty-plus]"), minus = $("[data-qty-minus]");
    if (plus) plus.addEventListener("click", function () {
      if (qty < 9) { qty++; qEl.textContent = qty; syncTotal(); }
    });
    if (minus) minus.addEventListener("click", function () {
      if (qty > 1) { qty--; qEl.textContent = qty; syncTotal(); }
    });

    /* ---------- add to cart ---------- */
    var variantId = root.dataset.variant;
    var available = root.dataset.available === "true";

    function refreshCartCount() {
      return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$("[data-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent("mp:cart-updated", { detail: cart }));
          return cart;
        });
    }

    function openDrawer() {
      // Dawn and most OS 2.0 themes
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.open === "function") { drawer.open(); return true; }
      var toggle = document.querySelector("#cart-icon-bubble, .header__icon--cart");
      if (toggle) { toggle.click(); return true; }
      return false;
    }

    $$("[data-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!available || !variantId) { window.location.href = "/cart"; return; }
        var original = btn.innerHTML;
        var amount = btn.hasAttribute("data-uses-qty") ? qty : 1;
        btn.disabled = true;
        btn.textContent = "Adding\u2026";

        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: amount }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "Add failed"); });
            return r.json();
          })
          .then(function () {
            return refreshCartCount();
          })
          .then(function () {
            btn.textContent = "Added \u2713";
            if (btn.hasAttribute("data-open-drawer")) openDrawer();
            setTimeout(function () {
              btn.innerHTML = original; btn.disabled = false; syncTotal();
            }, 1600);
          })
          .catch(function (err) {
            btn.textContent = "Couldn't add \u2014 try again";
            console.error("[mondopacks]", err);
            setTimeout(function () {
              btn.innerHTML = original; btn.disabled = false; syncTotal();
            }, 2200);
          });
      });
    });

    /* ---------- sticky bar ---------- */
    var hero = $("[data-hero]"), sticky = $("[data-sticky]");
    if (hero && sticky && hasIO) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle("on", !en[0].isIntersecting);
      }, { rootMargin: "-100px 0px 0px 0px" }).observe(hero);
    }

    refreshCartCount().catch(function () { /* cart unavailable in preview */ });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(".mp[data-section]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  // theme editor re-renders sections; re-initialise the new markup
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    e.target.querySelectorAll(".mp[data-section]").forEach(function (el) {
      el.dataset.mpReady = "";
    });
  });
})();
